import { type SpeakerSessionResponse } from '../hooks/useSpeakerSessionDetail';
import { unescape } from '../utils/escape';

class SpeakerSessionDto {
  readonly body: string;
  readonly id: number;
  readonly title: string;
  readonly thumbnail: string;
  readonly slug: string;
  readonly speaker: string;
  readonly location: string;
  readonly affiliation: string;
  readonly schedule: string;
  readonly trackName: string;
  readonly subType: string;
  readonly url: string;
  readonly type: string;
  readonly tags: string[];
  readonly hasSchedule: boolean;

  constructor(response: SpeakerSessionResponse) {
    this.body = response.data.body;
    this.id = response.data.id;
    this.title = unescape(response.data.title);
    this.thumbnail = response.data.url;
    this.slug = response.data.slug;
    this.speaker = response.data.data.speakerName;
    this.location = response.data.data.sessionLocation;
    this.affiliation = response.data.data.affiliation;
    this.schedule = response.data.data.sessionSchedule;
    this.trackName = response.data.data.trackName;
    this.subType = response.data.subType.toLowerCase();
    this.url = response.data.url;
    this.type = response.data.type;
    this.tags = response.data.data.trackName.split(/\s*,\s*/);
    this.hasSchedule = response.data.hasSchedule;
  }
}

export default SpeakerSessionDto;
